export function getCurrencySymbol({ locale, currency }: { locale: string; currency: string }) {
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(0).replace(/[0-9\s\.,]/g, '');
}